import { Link } from "react-router-dom";
import BreedCard from "@/components/BreedCard";
import SectionLabel from "@/components/SectionLabel";
import Reveal from "@/components/Reveal";
import { useLang } from "@/i18n/LanguageContext";
import { useLocalizedBreeds } from "@/i18n/hooks";

export default function Breeds() {
    const { t } = useLang();
    const breeds = useLocalizedBreeds();
    return (
        <div data-testid="breeds-page" className="bg-paper">
            <section className="pt-40 md:pt-48 pb-16 md:pb-24 container-editorial">
                <div className="flex items-center justify-between mb-8">
                    <SectionLabel label={t("breedsPage.label")} number="A" />
                    <Link
                        to="/quiz"
                        data-testid="breeds-take-quiz"
                        className="hidden md:inline-flex items-center gap-2 text-sm text-forest border border-forest px-5 py-2 rounded-full hover:bg-forest hover:text-paper transition-colors duration-300"
                    >
                        {t("common.buttons.notSureCta")}
                    </Link>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-16 items-end">
                    <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight md:col-span-8 whitespace-pre-line">
                        {t("breedsPage.heading")}
                    </h1>
                    <p className="md:col-span-4 text-ink/70 text-lg leading-relaxed">
                        {t("breedsPage.intro")}
                    </p>
                </div>
            </section>

            <section className="pb-24 md:pb-40 container-editorial">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
                    {breeds.map((b, i) => (
                        <Reveal key={b.slug} delay={i * 90}>
                            <BreedCard breed={b} index={i} />
                        </Reveal>
                    ))}
                </div>
            </section>

            <section className="pb-32 container-editorial">
                <Reveal>
                    <div className="max-w-3xl border-t border-border pt-12">
                        <div className="overlabel text-earth mb-4">{t("breedsPage.noteLabel")}</div>
                        <p className="text-ink/75 leading-relaxed text-lg">{t("breedsPage.noteBody")}</p>
                    </div>
                </Reveal>
            </section>
        </div>
    );
}
